import { AxiosRequestConfig } from 'axios';
import { injectable } from 'inversify';
import { ApiClient } from './ApiClient';

@injectable()
export class MockApiClient extends ApiClient {

    constructor() {
        super(null);
    }

    protected performRequest(req: AxiosRequestConfig, autoRetry401?: boolean, autoRetryNetwork?: number): Promise<[any, boolean, number]> {

        console.log(req.url);
        console.dir(req);

        return Promise.resolve([{ ok: true }, true, 200]);
    }
}
